<section class="info-container">
  <div class="preview-box">
    @if (program()?.seasons?.length) {
      <div class="preview-teaser-box">
        @if (programHasCopyright()) {
          <div class="program-copyright-section">
            <img src="/images/television-static-noise-black-white.svg" alt="program-copyright" />
            <div class="program-copyright-section-text">
              <span class="program-copyright-section-text-title">451 Error</span>
              <br />
              <span class="program-copyright-section-text-description">Unavailable for Legal Reasons</span>
            </div>
          </div>
        }
        <div class="preview-right-linear"></div>
        @if (episode()) {
          <app-image-generator [sizes]="billboardSizes" [src]="episode()!.landscapeImagePath" imageType="landscape" />
        }
        <div class="preview-box-title-treatment">
          <div class="preview-title-box">
            @if (program()) {
              <app-image-generator
                class="typography"
                [src]="program()!.program.typoGraphyImagePath + '?imgProcess=pr:fpng:w340'"
                [name]="program()!.program.title"
                [noBlurPlaceholder]="true"
                imageType="original"
              />
            }
            <div class="preview-operation-buttons">
              @if (!generalService.isSmallScreen()) {
                @if (programHasCopyright()) {
                  <app-button
                    class="play-btn"
                    Text="در لوکیشن شما در دسترس نیست"
                    Icon="public_off"
                    Appearance="warning"
                  />
                } @else {
                  @if (tokenService.userInfo()) {
                    @if (episode()?.releaseStatus === releaseStatusEnum.Released) {
                      @if (programService.canWatchInSiteProgram(episode()!)) {
                        <app-button
                          [IsButton]="true"
                          (Click)="handlePlayLink()"
                          [IsFillIcon]="true"
                          Icon="play_arrow"
                          Text="تماشا"
                          class="play-btn"
                          Appearance="secondary"
                        />
                      } @else {
                        <app-button class="play-btn" Text="خرید اشتراک" Icon="shop" Link="/account/plans" />
                      }
                    } @else if (episode()?.releaseStatus === releaseStatusEnum.ComingSoon) {
                      <app-button
                        [IsButton]="true"
                        Icon="schedule"
                        Text="به زودی"
                        class="play-btn"
                        Appearance="accent"
                      />
                    } @else {
                      <app-countdown-release [ReleaseDate]="episode()?.releaseDate" />
                    }
                  } @else {
                    <app-button
                      [IsButton]="true"
                      (Click)="handleLoginAndWatch()"
                      [IsFillIcon]="true"
                      Icon="play_arrow"
                      Text="ورود و تماشا"
                      class="play-btn"
                      Appearance="secondary"
                    />
                  }
                }

                <div class="interest-section">
                  <div
                    [class]="{ 'interest-box': true, 'active-interest': showDLLsection() }"
                    (mouseenter)="handleShowHoveredElement()"
                    (mouseleave)="handleLeaveHoveredElement()"
                  >
                    <app-icon-button
                      [IsButton]="true"
                      Appearance="default"
                      Icon="thumb_down"
                      [IsFillIcon]="selectedInterest() !== null && selectedInterest() === interestAction.Dislike"
                      [WithTooltip]="true"
                      TooltipText="نپسندیدم"
                      (Click)="handleInterestAction(interestAction.Dislike)"
                    />
                    <app-icon-button
                      [IsButton]="true"
                      Appearance="default"
                      Icon="thumb_up"
                      [IsFillIcon]="selectedInterest() !== null && selectedInterest() === interestAction.Like"
                      [WithTooltip]="true"
                      TooltipText="پسندیدم"
                      (Click)="handleInterestAction(interestAction.Like)"
                    />
                    <app-icon-button
                      [IsButton]="true"
                      Appearance="default"
                      Icon="favorite"
                      [IsFillIcon]="selectedInterest() !== null && selectedInterest() === interestAction.Love"
                      [WithTooltip]="true"
                      TooltipText="عاشقشم"
                      (Click)="handleInterestAction(interestAction.Love)"
                    />
                    <app-icon-button
                      [IsButton]="true"
                      class="close-interest-box"
                      Appearance="accent"
                      Icon="close"
                      (Click)="showDLLsection.set(false)"
                    />
                  </div>
                  <div class="like-btn" (mouseenter)="handleHoverOnLikeBtn()" (mouseleave)="handleLeaveOnLikeBtn()">
                    <app-icon-button
                      [IsButton]="true"
                      Appearance="accent"
                      [Loading]="submitInterest()"
                      (Click)="showDLLsection.set(true)"
                      [Icon]="
                        selectedInterest() && selectedInterest() === interestAction.Dislike
                          ? 'thumb_down'
                          : selectedInterest() && selectedInterest() === interestAction.Love
                            ? 'favorite'
                            : 'thumb_up'
                      "
                      [IsFillIcon]="selectedInterest() !== null"
                    />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="product-info-section">
        @if (program()) {
          @if (generalService.isSmallScreen()) {
            <app-product-info-mobile
              [ProgramData]="program()!"
              [Episode]="episode()!"
              [ProgramHasCopyright]="programHasCopyright()"
            />
          } @else {
            <app-product-info-desktop [ProgramData]="program()!" [Episode]="episode()!" />
          }
        }
        @if (program()?.seasons?.length) {
          <app-product-season
            [ProgramData]="program()!"
            [Episode]="episode()!"
            [ProgramHasCopyright]="programHasCopyright()"
          />
        }
        @if (program()?.cast?.length) {
          <div class="casts-wrapper" id="product-about-container">
            <app-product-cast [Casts]="program()!.cast" />
          </div>
        }
        @if (episodeTrailers().length) {
          <div class="mlt-wrapper">
            <app-product-trailers [Trailers]="episodeTrailers()" />
          </div>
        }
        @if (relatedPrograms().length) {
          <div class="mlt-wrapper">
            <app-sheyda-row [Data]="relatedPrograms()" RowTitle="مشابه این برنامه" />
          </div>
        }
        @if (program() && episode()) {
          <app-product-comment [ProgramData]="program()!" [Episode]="episode()!" />
        }
      </div>
    }
  </div>
</section>
